import { render, staticRenderFns } from "./NotificationTemplateInputs.vue?vue&type=template&id=1e9f2ba8&"
import script from "./NotificationTemplateInputs.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports